app.controller("IndexController", ["$scope", "$state", "AuthService",
    function ($scope, $state, AuthService) {
        AuthService.restore().then(function () {

            if (AuthService.authenticated) {
                $state.go("profile");
            }
            else {
                $state.go("login");
            }
        });
    }
]);